// The Outreach section's stage moves, in one place so the card menu, the deal
// page and App all record them the same way.
//
//   LOI Sent -> Confirmed Receipt -> Countered -> (into Pipeline)
//   LOI Sent -> Confirmed Receipt -> Declined
//
// "Did they confirm? did they counter?" has to stay answerable after the stage
// moves on, so each milestone is dated the first time it is reached - and a
// skipped step is implied by a later one (a counter means they received it).
// Moving forward takes the deal into Pipeline: deal_flow 'pipeline' at
// OUTREACH_PROMOTE_STAGE, dated promoted_at.

import { OUTREACH_PROMOTE_STAGE } from "../constants/dealStages";

export function outreachStagePatch(deal, newStage, now = new Date().toISOString()) {
  const patch = { deal_stage: newStage };
  const received = deal.confirmedReceiptAt;
  const countered = deal.counteredAt;
  if (newStage === "Confirmed Receipt" && !received) patch.confirmed_receipt_at = now;
  if (newStage === "Countered") {
    if (!countered) patch.countered_at = now;
    if (!received) patch.confirmed_receipt_at = now;
  }
  if (newStage === "Declined") patch.declined_at = now;
  else if (deal.declinedAt) patch.declined_at = null;      // reopened
  return patch;
}

export function promotePatch(now = new Date().toISOString()) {
  return { deal_flow: "pipeline", deal_stage: OUTREACH_PROMOTE_STAGE, promoted_at: now };
}

// Days until (negative = overdue) a follow-up date, or null.
export function followUpDays(deal, today = new Date()) {
  if (!deal?.followUpDate || ["Declined"].includes(deal.stage)) return null;
  const due = new Date(`${deal.followUpDate}T00:00:00`);
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return Math.round((due - t) / 86_400_000);
}

export const fmtMoneyShort = (v) => {
  if (v == null || v === "" || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return n >= 1_000_000 ? `$${(n / 1_000_000).toFixed(2).replace(/\.?0+$/, "")}M` : `$${Math.round(n).toLocaleString()}`;
};
export const fmtShortDate = (d) => (d ? new Date(String(d).length === 10 ? `${d}T00:00:00` : d)
  .toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");
